<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C8DzJn/images/ebook.jpg?1731429835409" alt="This image is the cover for the book Bats in the Belfry, Dan Shamble, Zombie P.I."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bats in the Belfry, Dan Shamble, Zombie P.I.
      </h1>
      <p class="bookDescription body article font2">
        <p>Ace Ventura meets the Addams Family!   A shambling horde of new cases hits Dan Shamble, Zombie P.I. in the Unnatural Quarter. Dan and his gang—including his ghost girlfriend, feisty lawyer partner, cop best friend, and little vampire half-daughter Alvina—are out to seek justice, solve mysteries, and keep their heads on straight … or at least attached.   Alvina’s singing lessons for the Banshee Tabernacle Choir end on a sour note when the troll choir director plunges to her death from a high belfry, and the only witness is a deaf-as-a-post gargoyle who sits too close to the loud bells.   A frustrated imp, woefully unsuccessful in betting on the nightmare races, is dead certain that his bookie BatGN (GN for “gender neutral” to avoid copyright issues) is cheating him.   Francine, the salty bartender at the Goblin Tavern, is worried when One Fang the vampire—her on-again, off-again suitor—disappears without a trace.   A shady vendor discovers a market for living shrunken heads that are conversational as well as decorative, but the demand by far exceeds the supply.   A heartless therapist has ulterior motives when she counsels zombies, distracting them from their woes to concentrate not just on brains, but on self-improvement as well.   There is much at stake in the Unnatural Quarter, and it’s up to Dan Shamble to keep the streets dark and safe for monsters and humans alike. After all, the cases don’t solve themselves!   This zombie detective puts the P.I. back in R.I.P.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin J. Anderson
      </h2>
      
      <p class="authorDescription body article">Kevin J. Anderson has published more than 180 books, 58 of which have been national or international bestsellers. He has 24 million copies in print in 34 languages.   He has written numerous novels in the Star Wars, X-Files, and Dune universes, as well as the unique Clockwork Angels steampunk trilogy with legendary Rush drummer Neil Peart. His original works include the Saga of Seven Suns series, the Wake the Dragon and Terra Incognita fantasy trilogies, the humorous Dan Shamble, Zombie P.I. series and The Dragon Business series.   He has edited numerous anthologies, written comics and games, and the lyrics to two rock CDs as companions to his Terra Incognita trilogy.   Anderson is the director of the graduate program in Publishing at Western Colorado University, and he and his wife Rebecca Moesta are the publishers of WordFire Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29e44828